import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Backdrop(theme) {
  const isDark = theme.palette.mode === 'dark';
  const backdropBg = isDark
    ? alpha(theme.palette.background.default || '#0B0E14', 0.9)
    : alpha('#0F172A', 0.45); // Soft dark slate overlay in light mode for content contrast

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: 'none',
          backgroundColor: backdropBg,
          '&.MuiBackdrop-invisible': {
            background: 'transparent',
            backgroundColor: 'transparent',
          }
        }
      }
    }
  };
}
